<template>
<div id="app" class="w-100">
    <nav  class="sticky-top navbar navbar-expand-lg navbar-dark bg-primary">
        <a class="navbar-brand"  href="#page1"> <img alt="Vue logo" src="./assets/full_logo_gw.svg" height="35" class=""> </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul id="menu" class="navbar-nav ml-auto font-weight-medium  text-uppercase">
                <li data-menuanchor="page1" class="nav-item active">
                    <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 12 2.0996094 L 1 12 L 4 12 L 4 21 L 10 21 L 10 14 L 14 14 L 14 21 L 20 21 L 20 12 L 23 12 L 12 2.0996094 z"/></svg>
                    </a>
                </li>
                <li data-menuanchor="page2" class="nav-item"><a href="#about-us">About Us</a></li>
                <li data-menuanchor="page3" class="nav-item"><a href="#the-team">The Team</a></li>
                <li data-menuanchor="page4" class="nav-item"><a href="#track-record">Track Record</a></li>
                <li data-menuanchor="page5" class="nav-item"><a href="#strategy">Strategy</a></li>
                <li data-menuanchor="page6" class="nav-item"><a href="#social-impact">Social Impact</a></li>
                <li data-menuanchor="page7" class="nav-item"><a href="#contact">Contact Us</a></li>
            </ul>
        </div>
    </nav>
    <div class="home cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
        <div class="inner cover col-md-8 col-lg-7 col-xl-6 p-lg-5 m-auto text-center">
            <h1 class="cover-heading "><img alt="Vue logo" src="./assets/full_logo_wg.svg" class=""></h1>
            <!--<p class="lead text-light font-weight-semi-bold">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus tincidunt elit non porta semper. Sed tincidunt maximus odio, id malesuada quam aliquet eu.
            </p>
            <p class="lead">
                <a href="#page2" class="btn btn-lg btn-primary">Learn more</a>
            </p>-->
        </div>
    </div>

    <div class="bg-dark cover-container  pb-5 ">
        <div class="bg-dark  container-xl  box-content row no-gutters p-3  m-auto">
            <div class="col-12 col-md-4 col-xl-3 text-center d-none d-md-block ">
                <!--<img  src="./assets/aboutus.jpg" class=" img-fluid  mt-5 shadow-lg" >-->
                <div class="mt-5 pt-5"><p class="text-white mt-5 pt-5 font-weight-medium">Formed in 2019 by seasoned multifamily real estate investors</p></div>
            </div>
            <div class="offset-md-1 col-12 col-md-7 col-xl-8">
                <h1 id="about-us" class="text-white text-uppercase">About Us</h1>
                <div class="box-top-bar rounted-top  mb-2 bg-primary"></div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    Members of the founding team have transacted over <span class="font-weight-bold">$150 million</span> in multifamily and commercial real estate investments (approximately 2,800 units) in the last 5 years, with a gross IRR exceeding 30%
                </div>
                <div class="text px-4 py-3 mb-1 bg-white shadow">
                    We intend to utilize our experience in multifamily real estate coupled with technology, including <span class="font-weight-bold">AI-based tools</span>, to identify opportunities where we can create <span class="font-weight-bold">above-market returns</span>
                </div>
                <div class="text px-4 py-3 mb-1 bg-white shadow">
                    Our 'boots on the ground' approach is expected to <span class="font-weight-bold">leverage strong relationships with key local players</span>, including government, vendors and banks, to access off-market deals and streamline our investment process
                </div>
                <div class="text px-4 py-3 mb-1 rounded-bottom bg-white shadow">
                    We expect to employ state of the art technology in our property upgrade process to deliver high quality results while striving to realize <span class="font-weight-bold">cost efficiencies and reduced timeframes</span> compared to our peers
                </div>
            </div>
        </div>
    </div>

    <div class="team bg-white  my-5 py-5 ">
        <div class="box-content  container-xl row no-gutters d-flex mx-auto flex-column">
            <div class="col-12">
                <h1 id="the-team" class="text-primary text-uppercase mt-3 text-lg-right">The Team</h1>
                <div class="box-top-bar rounted-top  mb-2 bg-primary"></div>
                <div class="row ">
                    <div class="col-lg-4 col-sm-6 col-12 pt-5">
                        <div class="text-center"><img src="./assets/serge.jpg" class="img-fluid"></div>
                        <div class="rounded-bottom bg-white shadow p-3">
                            <h3 class="text-center">Serge Yammine</h3>
                            <div class="team-text-box">
                                <p>Serge Yammine is a founding partner of Falconvest Partners LLC. As Chief Executive Officer, Serge oversees investment decisions, marketing and governance of the Partnership.</p>
                            </div>
                            <!-- Button trigger modal -->
                            <button type="button" class="btn btn-primary btn-block" data-toggle="modal" data-target="#sergeModal">
                            Read More
                            </button>
                            <!-- Modal -->
                            <div class="modal fade" id="sergeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalLongTitle">Serge Yammine</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <p>Serge Yammine is a founding partner of Falconvest Partners LLC. As Chief Executive Officer, Serge oversees investment decisions, marketing and governance of the Partnership.</p>
                                            <p>Prior to founding FalconVest Partners, Serge also co-founded and managed 4855 Orange, LLC., a real estate investment firm focusing on multi-family and commercial properties. His tasks included deal sourcing, underwriting, managing, and negotiating the purchase and sale of it’s real estate holdings.</p>
                                            <p>
                                                Serge has more than 10 years of experience in real estate, and been involved in execution of over $100 million in multi-family and commercial real estate, focusing on the United States market.
                                            </p>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div><!-- end modal -->
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12 pt-5">
                        <div class="text-center"><img src="./assets/sameer.jpg" class="img-fluid"></div>
                        <div class="rounded-bottom bg-white shadow p-3 ">
                            <h3 class="text-center">Sameer Abdi</h3>
                            <div class="team-text-box">
                                <p>Sameer Abdi is a founding partner of FalconVest Partners LLC where he is responsible for investment screening, acquisition advisory and investor relations.</p>
                            </div>
                            <!-- Button trigger modal -->
                            <button type="button" class="btn btn-primary btn-block" data-toggle="modal" data-target="#sameerModal">
                                Read More
                            </button>
                            <!-- Modal -->
                            <div class="modal fade" id="sameerModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalLongTitle">Sameer Abdi</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <p>Sameer Abdi is a founding partner of FalconVest Partners LLC where he is responsible for investment screening, acquisition advisory and investor relations.</p>
                                            <p>From 2007 to 2019, Sameer served as a Senior Partner with EY LLP (Ernst & Young) in the firm’s Financial Advisory and Mergers & Acquisitions practices.  During his 22 years of service at EY, Sameer led over $12 billion in buy side acquisitions for institutional clients, focusing on  real estate and energy assets in the North & South America, Western Europe and South East Asia. </p>
                                            <p>Sameer has a degree in Mechanical Engineering from Imperial College (University of London, England). He is also a Fellow Chartered Accountant of the Institute of Chartered Accountants of England and Wales. Sameer is a published author in asset management and a graduate of the the highly competitive Harvard University Strategic Leadership Program.</p>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div><!-- end modal -->
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12 pt-5">
                        <div class="text-center"><img src="./assets/ralph.jpg" class="img-fluid"></div>
                        <div class="rounded-bottom bg-white shadow p-3 ">
                            <h3 class="text-center">Ralph Yammine</h3>
                            <div class="team-text-box">
                                <p>Ralph Yammine is a founding partner of Falconvest Partners LLC and is responsible for identifying real estate investments and deal structuring.</p>
                            </div>
                            <!-- Button trigger modal -->
                            <button type="button" class="btn btn-primary btn-block" data-toggle="modal" data-target="#ralphModal">
                            Read More
                            </button>
                            <!-- Modal -->
                            <div class="modal fade" id="ralphModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalLongTitle">Ralph Yammine</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <p>Ralph Yammine is a founding partner of Falconvest Partners LLC and is responsible for identifying real estate investments and deal structuring.</p>
                                            <p>Ralph is an attorney with a focus on real estate and has been licensed since 1997. He has been involved in numerous real estate deals in the multi-family, hospitality, and retail sectors in the U.S. market.</p>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div><!-- end modal -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- end team -->


    <!--begin track record -->
    <div class="bg-dark cover-container  pb-5 ">
        <div class="bg-dark container-xl  box-content row no-gutters p-3  m-auto">

            <div class="col-12 col-md-7 col-xl-8">
                <h1 id="track-record" class="text-white text-uppercase">Track Record</h1>
                <div class="box-top-bar rounted-top  mb-2 bg-primary"></div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2 class="font-weight-bold text-center text-md-left">$150 million</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <p class="text-center text-md-right mt-md-2">
                                in multifamily real estate exits
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2 class="font-weight-bold text-center text-md-left">$85 million</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <p class="text-center text-md-right mt-md-2">
                                in current portfolio holdings
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2 class="font-weight-bold text-center text-md-left">30%</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <p class="text-center text-md-right mt-md-2">
                                gross IRR
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2 class="font-weight-bold text-center text-md-left">9%</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <p class="text-center text-md-right mt-md-2">
                                cash yield
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2 class="font-weight-bold text-center text-md-left">2x</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <p class="text-center text-md-right mt-md-2">
                                equity multiple to investors
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2 class="font-weight-bold text-center text-md-left">15</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <p class="text-center text-md-right mt-md-2">
                                acquisitions in 7 states
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2 class="font-weight-bold text-center text-md-left">2,800 units</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <p class="text-center text-md-right mt-md-2">
                                managed in 23 properties
                            </p>
                        </div>
                    </div>
                </div>
            </div>
             <div class="offset-md-1 col-12 col-md-4 col-xl-3 d-none d-md-block ">

                <div class="mt-5 pt-5">
                    <h2 class="text-white text-uppercase font-weight-bold"> Since 2014</h2>
                    <p class="text-white font-weight-medium">Members of the founding team have invested and exited a portfolio of assets with exeptional returns</p>
                </div>
            </div>
        </div>
    </div>


    <div class="bg-white my-5 py-5 ">
        <div class="container-xl box-content  p-3 m-auto">
            <h1 id="strategy" class="text-uppercase pb-0">Our Strategy</h1>
            <p> We deploy a 9-point investment thesis in our strategy</p>
            <div class="box-top-bar bg-dark"></div>
            <div class="p-1 bg-primary"></div>
            <div class="row shadow no-gutters pt-5">
                <div class="col-6 col-lg-4  mb-5 text-center">
                    <img src="./assets/icon_growing_cities.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">Growing Cities</div>
                </div>
                <div class="col-6 col-lg-4 mb-5 text-center">
                    <img src="./assets/icon_popular_growth.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">
                    Population Growth
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-5 text-center">
                    <img src="./assets/icon_strong_locations.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">
                    Strong Location
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-5 text-center">
                    <img src="./assets/icon_expanding_economies.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">
                    Expanding Economies
                    </div>
                </div>
                <div class="col-6 col-lg-4  mb-5 text-center">
                    <img src="./assets/icon_experienced_operators.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">
                    Experienced Operators
                </div>
                </div>
                <div class="col-6 col-lg-4 mb-5 text-center">
                    <img src="./assets/icon_upside_potential.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">
                    Upside Potential
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-5 text-center">
                    <img src="./assets/icon_attractive_basis.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">
                    Attractive Basis
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-5 text-center">
                    <img src="./assets/icon_demographic_demand.svg" class="img-icon" />
                    <div class="mt-2 text-uppercase">
                    Demographic Demand
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-5 text-center">
                    <img src="./assets/icon_social_impact.svg" class="img-icon py-3" />
                    <div class="mt-2 text-uppercase">
                    Social Impact
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--begin contact -->
     <div class="bg-dark cover-container  pb-5 ">
        <div class="bg-dark  container-xl  box-content row no-gutters p-3  m-auto">
            <div class="col-12 col-md-4 col-xl-3 text-center d-none d-md-block ">
                <img  src="./assets/globe_hand.jpg" class="img-fluid" >
            </div>
            <div class="offset-md-1 col-12 col-md-7 col-xl-8">
                <h1 id="social-impact" class="text-white text-uppercase">Social Impact</h1>
                <div class="box-top-bar rounted-top  mb-2 bg-primary"></div>
                <div class="text px-4 py-3 bg-white shadow mb-1">
                    <div class="media">
                        <img width="50" src="./assets/icon_esg.svg" class="img-icon mr-3" />
                        <div class="media-body">
                            We incorporate environmental, social and governance (ESG) criteria in our investment decisions to combine social impact with financial performance
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 mb-1 bg-white shadow">
                    <div class="media">
                        <img width="50" src="./assets/icon_esg.svg" class="img-icon mr-3" />
                        <div class="media-body">
                            We are committed to making decisions in employment, operations, and investments to drive positive community engagement
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 mb-1 bg-white shadow">
                    <div class="media">
                        <img width="50" src="./assets/icon_esg.svg" class="img-icon mr-3" />
                        <div class="media-body">
                            Our processes seek to reduce environment resource intensity, energy & water consumption, carbon intensity and waste
                        </div>
                    </div>
                </div>
                <div class="text px-4 py-3 mb-1 rounded-bottom bg-white shadow">
                    <div class="media">
                        <img width="50" src="./assets/icon_esg.svg" class="img-icon mr-3" />
                        <div class="media-body">
                            We believe these efforts potentially increase the Fund's ability to access exclusive opportunities, expedite regulatory approvals and achieve longer tenant occupancy
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="p-3 mb-1 bg-primary"></div>
    <div class="p-1 mb-2 bg-white"></div>
     <!--begin contact -->
    <div class="bg-dark py-5">
        <div class="container-xl  box-content row no-gutters m-auto">
            <div class=" col-12 col-md-7 col-xl-8">
                <h1 id="contact" class="text-white text-uppercase">Contact Us</h1>
                <div class="box-top-bar mb-2 bg-dark"></div>
                <div>
                    <div class="container contact-form bg-white">
                        <div class="contact-image">
                            <img src="./assets/document.png" class="img-fluid shadow-sm" alt="rocket_contact"/>
                        </div>
                        <form method="post" action="mailto:gp@falconvestpartners.com">
                            <div class="row p-5">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" name="contact-name" class="form-control" placeholder="Your Name *" value="" />
                                    </div>
                                    <div class="form-group">
                                        <input type="text" name="contact-email" class="form-control" placeholder="Your Email *" value="" />
                                    </div>
                                    <div class="form-group">
                                        <input type="text" name="contact-phone" class="form-control" placeholder="Your Phone Number *" value="" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <textarea name="contact-message" class="form-control" placeholder="Your Message *" style="width: 100%; height: 150px;"></textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <input type="submit" name="btnSubmit" class="btn btn-primary" value="Send Message" />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="offset-md-1 col-12 col-md-4 col-xl-3  d-none d-md-block ">
                <div class="mt-5 pt-5">
                    <p class="text-white mt-5 pt-5 font-weight-medium">
                        FalconVest Partners, LLC<br/>
                        gp@falconvestpartners.com<br/>
                    +1 305-349-3398</p>
                </div>
            </div>
        </div>
    </div>

        <div class="bg-dark footer">
        </div>
</div>
</template>
<script>
export default {
name: 'app',
data () {
return {
options: {
}
}
},
methods: {
afterLoad () {
},
}
}
</script>
<style lang="scss">
$theme-colors: (
"primary": #23ce93,
"dark": #333,
);
html,
body {
height: 100%;
width: 100%;background-color: #333;
}
body {
display: -ms-flexbox;
display: -webkit-box;
display: flex;
-ms-flex-pack: center;
-webkit-box-pack: center;
justify-content: center;
}
.img-icon {
    max-height: 160px;
}
@media screen and (max-width: 480px) {
    .img-icon {
        max-height: 90px;
    }

}
.box-top-bar {
height: 20px;
}
.cover-container.home{
background: url("./assets/cover.jpg") no-repeat scroll 0px 100% / cover transparent;
background-position: center;
}
.footer-top{
background: url("./assets/footer.png") repeat-x;
background-position: bottom;
width: 100%;
height:90px;
}
.team-text-box {
min-height: 140px;
}
.team .img-fluid {
max-width: 280px;
}
.contact-form{
width: 70%;
}
.contact-form .form-control{
}
.contact-image{
text-align: center;
}
.contact-image img{
border-radius: 6rem;
width: 80px;
margin-top: -4%;
}
.contact-form form .row{
margin-bottom: -7%;
}
.contact-form h3{
text-align: center;
color: #0062cc;
}
.footer {
height: 50px;
}
.cover-container.footer{
background: url("./assets/footer_bg_2.jpg") repeat-x;
background-position: bottom;
}
@import 'bootstrap/scss/bootstrap-reboot.scss';
@import 'bootstrap/scss/bootstrap-grid.scss';
@import 'bootstrap/scss/bootstrap.scss';
@import './styles/main.scss';
</style>